import React, { useImperativeHandle, forwardRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { useAddressQuery } from '../../app/config/redux/slices/api/userApiSlice';
import { useDeleteAddressMutation } from '../../app/config/redux/slices/api/addressApiSlice';

const AddressList = forwardRef(({ setSelectedAddress, selectedAddress, token }, ref) => {


    const [deleteAddress] = useDeleteAddressMutation();


    const { data, isLoading, isFetching, refetch ,error } = useAddressQuery({ token });

    const addresses = data?.data || [];
    
    useImperativeHandle(ref, () => ({
        triggerRefetch: () => {
            console.log('triggerRefetch called from parent'); // 👈 Log
            refetch();
        },
    }));

    useEffect(() => {
        if (addresses.length > 0 && !selectedAddress) {
            setSelectedAddress(addresses[0].id);
        }
    }, [addresses, selectedAddress, setSelectedAddress]);


    if (isLoading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;


    




    const handleDelete = async (id) => {
        try {
            await deleteAddress({ id, token }).unwrap();
            console.log("Address deleted successfully!");
            refetch();
        } catch (error) {
            console.log(error?.data?.message || "Failed to delete address");
        }
    };

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: false,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: 4,

                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 4,

                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,

                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,

                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 1,

                },
            },

        ],
    };
    return (
        <section className="new-arrival pb-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Select an address</h5>
                        <div className="flex-align mr-point gap-16">
                            <Link
                                to="/shop"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                View All Address
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="new-arrival__slider arrow-style-two">
                    <Slider {...settings}>

                    {addresses.map(address => (

                        <div key = {address.id} id={`address-${address.id}`}>
                            <div
                            className={`product-card px-8 py-16 border ${
                                selectedAddress === address.id ? 'border-main-600' : 'border-gray-100'
                            } hover:border-main-600 rounded-16 position-relative transition-2`}
                            >
                                <div className="product-card__content mt-12">
                                    <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                        <Link to="/product-details" className="link text-line-2">
                                           {address.name},{address.mobile}
                                        </Link>
                                    </h6>
                                    <div className="flex-align gap-4">
                                        <br/>
                                        <span className="text-gray-500 text-xs">
                                            {address.house},{address.area}<br/>
                                            {address.city},{address.district_name},{address.state_name}, {address.country_name}<br/>
                                            Pincode: {address.pincode}<br/>
                                            Landmark : {address.landmark}<br/>
                                        </span>
                                    </div>
                                    <div className="flex-between gap-8 mt-24 flex-wrap">
                                        <button
                                            onClick={() => {
                                                setSelectedAddress(address.id);
                                            }}
                                            className="product-card__cart btn btn-main py-11 px-24 rounded-pill flex-align gap-8"
                                        >
                                            Select
                                        </button>
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevent selecting the address when clicking delete
                                                if (window.confirm("Are you sure you want to delete this address?")) {
                                                    handleDelete(address.id);
                                                }
                                            }}
                                            className="product-card__cart btn btn-main py-11 px-24 rounded-pill flex-align gap-8"
                                        >
                                            <i className="ph ph-trash" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    </Slider>
                </div>
            </div>
        </section>

    )
});

export default AddressList